module.exports = __webpack_public_path__ + "media/03 the Lantern Festival.5f171b83.mp3";